import React, { useState, useCallback } from 'react'
import t from '~t'
import { useDispatch } from 'react-redux'
import { appendTagsSelected } from '~data/actions/bookmarks'

import { Button, Icon } from '~ui'
import TagsPicker from '~co/picker/tags'

export default function BookmarksHeaderSelectModeAddTags({ selectMode = {} }) {
    const dispatch = useDispatch()
    const [show, setShow] = useState(false)
    const [tags, setTags] = useState([])
    const { spaceId, all, ids = [] } = selectMode

    const onClick = useCallback(() => setShow(true), [])
    const onClose = useCallback(() => setShow(false), [])

    const onSubmit = useCallback(() => {
        if (tags.length)
            dispatch(appendTagsSelected(spaceId, tags))
        setShow(false)
    }, [dispatch, spaceId, tags])

    return (
        <>
            <Button
                variant='outline'
                title={t.s('addTags')}
                disabled={!all && !ids.length}
                onClick={onClick}>
                <Icon name='tag' />

                <span className='hide-on-small-body'>{t.s('addTags')}</span>
            </Button>

            {show && (
                <TagsPicker
                    value={tags}
                    spaceId={spaceId}
                    onChange={setTags}
                    onSubmit={onSubmit}
                    onClose={onClose} />
            )}
        </>
    )
}
